<template>
	<v-container align-center>
		<v-layout justify-center>
			<v-flex>
				<v-layout justify-center pb-3>
					<v-btn
						class="btn white--text mr-2 px-5"
						:color="themeInputColor"
						@click="openCreateSchemeModal()"
					>
						Create New Scheme
					</v-btn>
				</v-layout>
				<v-layout justify-center row wrap>
					<v-flex>
						<v-autocomplete
							label="Select User Type"
							v-model="selectedUserType"
							:items="Object.keys(storeTypes)"
							autocomplete
							placeholder="Select User Type"
							:color="themeInputColor"
							:loading="isFetchingSchemes"
							clearable
							box
						/>
					</v-flex>
					<v-flex>
						<v-autocomplete
							label="Select State"
							v-model="selectedState"
							:items="states"
							autocomplete
							placeholder="Select State"
							:color="themeInputColor"
							:loading="isFetchingSchemes"
							box
							clearable
						/>
					</v-flex>
				</v-layout>
				<v-layout justify-center>
					<v-btn
						round
						:dark="!!selectedUserType && !!selectedState"
						:color="themeInputColor"
						:disabled="!selectedUserType || !selectedState"
						:loading="isFetchingSchemes"
						@click="fetchSchemes"
					>
						Search
					</v-btn>
				</v-layout>
				<v-layout justify-center>
					<v-btn
						icon
						right
						bottom
						fixed
						small
						fab
						:color="themeInputColor"
						@click="$vuetify.goTo(0)"
					>
						<v-icon color="#fff">keyboard_arrow_up</v-icon>
					</v-btn>
				</v-layout>
				<v-layout justify-center py-1>
					<v-flex row>
						<v-card
							hover
							class="scheme-card"
							v-for="scheme in allSchemes"
							:key="scheme.id"
							@click="openCreateSchemeModal(scheme)"
						>
							<v-img :src="scheme.imageURL" alt="scheme" />
							<v-card-actions>
								<v-btn outline round :color="themeInputColor">
									Edit
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<create-scheme
			:showDialog="showDialog"
			:themeInputColor="themeInputColor"
			:isEdit="isEdit"
			:storeTypes="storeTypes"
			:states="states"
			:selectedScheme="selectedScheme"
			@closeDialog="closeDialog"
		/>
	</v-container>
</template>

<script>
import { mapState } from "vuex";
import {
	JEET_11_AGENT,
	JEET_11_CAPTAIN,
	JEET_11_DISTRIBUTOR,
	JEET_11_EXECUTIVE,
	JEET_11_PARTNER,
	JEET_11_PROMOTER,
	JEET_11_RBM,
	JEET_11_TSM,
	JEET_11_SHOPBOY
} from "../../../store/config";
import { FETCH_RETAIL_SCHEMES } from "../../../store/action-types";
import CreateScheme from "./create-scheme.vue";
import { RUMMY_COLOUR, THEME_INPUT_COLOUR } from "../../constants";

export default {
	components: {
		"create-scheme": CreateScheme
	},
	data() {
		return {
			selectedUserType: "",
			selectedState: "",
			storeTypes: {
				[JEET_11_PARTNER]: "dstrRetail",
				[JEET_11_EXECUTIVE]: "executive",
				[JEET_11_DISTRIBUTOR]: "dstr",
				[JEET_11_CAPTAIN]: "captain",
				[JEET_11_PROMOTER]: "promoter",
				[JEET_11_TSM]: "tsm",
				[JEET_11_RBM]: "rbm",
				[JEET_11_AGENT]: "dstrRetail",
				[JEET_11_SHOPBOY]: "dstrRetail"
			},
			isFetchingSchemes: false,
			allSchemes: [],
			showDialog: false,
			isEdit: false,
			selectedScheme: {},
			themeInputColor: THEME_INPUT_COLOUR,
			rummyInputColor: RUMMY_COLOUR
		};
	},
	computed: {
		...mapState({
			states: state => state.common.states
		})
	},
	methods: {
		fetchSchemes() {
			if (this.fetchingSchemes) return;
			this.isFetchingSchemes = true;
			this.$store
				.dispatch(FETCH_RETAIL_SCHEMES.dispatch, {
					state: this.selectedState,
					userType: this.storeTypes[this.selectedUserType]
				})
				.then(schemes => {
					this.allSchemes = schemes;
				})
				.finally(() => {
					this.isFetchingSchemes = false;
				});
		},
		closeDialog() {
			this.showDialog = false;
			if (this.selectedState && this.selectedUserType)
				this.fetchSchemes();
		},
		openCreateSchemeModal(schemeToBeEdited = {}) {
			this.isEdit = Object.keys(schemeToBeEdited).length > 0;
			this.selectedScheme = schemeToBeEdited;
			this.showDialog = true;
		}
	}
};
</script>

<style lang="scss">
.scheme-card {
	border-radius: 6px;
	margin: 1em 0;
	padding: 0.5em;
	display: flex;
	flex-direction: column;
}
</style>
